import { isEmpty, removeFalsyValues } from '~/core/helpers/object.helper';
import { ActivityPlanningDateSelectionInterface } from '~/organizer/activity-planning/components/shared/date-selection/interfaces/date-selection.interface';

export function isDateSelectionValidRecurrence(
  dateSelection: ActivityPlanningDateSelectionInterface
): boolean {
  return Boolean(
    dateSelection.recurrent?.endDate &&
      !isEmpty(removeFalsyValues(dateSelection.recurrent?.days)) &&
      dateSelection.startDate &&
      dateSelection.startTime
  );
}

export function isDateSelectionValidSingleDate(
  dateSelection: ActivityPlanningDateSelectionInterface
): boolean {
  return Boolean(
    !dateSelection.recurrent &&
      dateSelection.startDate &&
      dateSelection.startTime
  );
}

export function isDateSelectionRangeValid(
  dateSelection: ActivityPlanningDateSelectionInterface
): boolean {
  return Boolean(
    dateSelection?.startDate &&
      dateSelection.recurrent?.endDate &&
      new Date(dateSelection.startDate).getTime() <
        new Date(dateSelection.recurrent.endDate).getTime()
  );
}
